import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faTiktok, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { ApiService } from "../../ApiService";
import { useCompanyAssigned } from "../../CompanyAssignedContext";
import { useParams } from "react-router-dom";

import {
	IconButton,
	Tooltip,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Button,
	Skeleton,
	Box,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import imagen_celular from "../../../images/celular_redes.png";
import globitos from "../../../images/globitos_redes.png";
import Alert from "@mui/material/Alert";
import { RedesSkeleton } from "./RedesSkeleton";
import { toast } from "react-toastify";

const socialMediaList = [
	{ name: "Whatsapp", icon: faWhatsapp, key: "wp_url", defaultUrl: "https://wa.me" },
	{ name: "Tiktok", icon: faTiktok, key: "tiktok_url", defaultUrl: "https://www.tiktok.com" },
	{ name: "Facebook", icon: faFacebookF, key: "fb_url", defaultUrl: "https://www.facebook.com" },
	{ name: "Instagram", icon: faInstagram, key: "ig_url", defaultUrl: "https://www.instagram.com" },
];

const HomeRedesEdit = ({ keyBranch, socialMediaUrls, loading }) => {
	const [urls, setUrls] = useState([
		"https://wa.me",
		"https://www.tiktok.com",
		"https://www.facebook.com",
		"https://www.instagram.com",
	]);

	const [editIndex, setEditIndex] = useState(null);
	const [tempUrl, setTempUrl] = useState("");
	const [activeUrlKey, setActiveUrlKey] = useState(null);
	const [urlError, setUrlError] = useState(null);

	const { nit } = useParams();
	const { companyAssigned = [] } = useCompanyAssigned() || [];

	// Para imagen
	const [modalImageOpen, setModalImageOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState(null);
	const [celularImage, setCelularImage] = useState(imagen_celular);
	const [isLoading, setIsLoading] = useState(false);
	useEffect(() => {
		if (socialMediaUrls) {
			const newUrls = [...urls];
			socialMediaList.forEach((item, index) => {
				if (socialMediaUrls[item.key]) {
					newUrls[index] = socialMediaUrls[item.key];
				}
			});
			setUrls(newUrls);
		}
	}, [socialMediaUrls]);
	const isValidUrl = (url) => {
		try {
			new URL(url);
			return true;
		} catch (_) {
			return false;
		}
	};

	const handleOpenDialog = (socialMedia, index) => {
		setActiveUrlKey(socialMedia.key);
		setTempUrl(urls[index] || socialMedia.defaultUrl);
		setEditIndex(index);
	};
	const handleKeyDown = (e) => {
		if (e.key === "Enter" && !e.shiftKey) {
			e.preventDefault();
			handleSaveUrl();
		}
	};
	const handleSaveUrl = async () => {
		setUrlError(null);
		setIsLoading(true);
		if (!isValidUrl(tempUrl) && tempUrl.trim() !== "") {
			setUrlError("Por favor ingrese una URL válida");
			return;
		}

		if (isValidUrl(tempUrl) && activeUrlKey) {
			const body = {
				[activeUrlKey]: tempUrl,
			};
			const url = `api/company/update/main?key_branch=${keyBranch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify(body),
			};
			const response = await ApiService.fetchData(url, payload);

			if (response?.code === 200) {
				const newUrls = [...urls];
				newUrls[editIndex] = tempUrl;
				setUrls(newUrls);
				toast.success(response?.message??"Actualizacion realizada exitosamente");
				
			}
		}
		setIsLoading(false);
		setEditIndex(null);
		setActiveUrlKey(null);
	};
	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			const preview = URL.createObjectURL(file);
			setPreviewImage(preview);
		}
	};

	const handleSaveImage = () => {
		if (previewImage) {
			setCelularImage(previewImage);
			setPreviewImage(null);
		}
		setModalImageOpen(false);
	};

	const handleRemovePreview = () => {
		setPreviewImage(null);
	};
	if (loading) {
		return <RedesSkeleton />;
	}

	return (
		<div className="redes-company" style={{ backgroundColor:'var(--theme-company)' }} >
			<div className="title-redes">
				<div className="title-redes-one">
					<span style={{ color:'var(--theme-company)' }}>Siguenos en nuestras</span>
				</div>
				<div className="title-redes-two">
					<span>Redes Sociales</span>
				</div>
				<div className="title-redes-two-celular">
					<span>Redes Sociales</span>
				</div>
			</div>

			<div className="redes-one">
				<div className="social-links">
					{socialMediaList.slice(0, 2).map((item, index) => (
						<div className="section-social" key={index}>
							<a
								href={isValidUrl(urls[index]) ? urls[index] : "#"}
								target="_blank"
								rel="noopener noreferrer">
								<FontAwesomeIcon
									style={{ fontSize: "35px", position: "relative", left: "22px", top: "16px" }}
									icon={item.icon}
									className="icon"
								/>
							</a>
							<Tooltip title={`Editar URL de ${item.name}`} placement="top">
								<IconButton
									size="small"
									onClick={() => handleOpenDialog(item, index)}
									sx={{
										"position": "absolute",
										"top": 5,
										"right": 5,
										"border": "1px solid #000",
										"backgroundColor": "#e62e2d",
										"zIndex": 1000,
										"&:hover": { backgroundColor: "#e62e2d" },
									}}>
									<EditIcon fontSize="small" sx={{ color: "#fff" }} />
								</IconButton>
							</Tooltip>
						</div>
					))}
				</div>
			</div>

			<div className="redes-two">
				<div className="social-links">
					{socialMediaList.slice(2).map((item, idx) => {
						const index = idx + 2;
						return (
							<div className="section-social red-fb" key={index}>
								<a
									href={isValidUrl(urls[index]) ? urls[index] : "#"}
									target="_blank"
									rel="noopener noreferrer">
									<FontAwesomeIcon
										style={{ fontSize: "35px", position: "relative", left: "22px", top: "16px" }}
										icon={item.icon}
										className="icon"
									/>
								</a>
								<Tooltip title={`Editar URL de ${item.name}`} placement="top">
									<IconButton
										size="small"
										onClick={() => handleOpenDialog(item, index)}
										sx={{
											"position": "absolute",
											"top": 5,
											"right": 5,
											"backgroundColor": "#e62e2d",
											"border": "1px solid #000",
											"zIndex": 1000,
											"&:hover": { backgroundColor: "#e62e2d" },
										}}>
										<EditIcon fontSize="small" sx={{ color: "#fff" }} />
									</IconButton>
								</Tooltip>
							</div>
						);
					})}
				</div>
			</div>

			<div className="redes-photo">
				<div className="section-social-globitos">
					<img src={globitos} alt="globitos" className="globitos-img" />
					<div className="section-social-photo">
						<img src={celularImage} alt="celular" className="celular-img" />
						<Tooltip title="Editar imagen">
							<IconButton
								size="small"
								onClick={() => setModalImageOpen(true)}
								sx={{
									"position": "absolute",
									"top": 5,
									"right": 5,
									"backgroundColor": "#e62e2d",
									"border": "1px solid #000",
									"zIndex": 1000,
									"&:hover": { backgroundColor: "#e62e2d" },
								}}>
								<EditIcon fontSize="small" sx={{ color: "#fff" }} />
							</IconButton>
						</Tooltip>
					</div>
				</div>
			</div>

			{/* Modal para URL */}
			<Dialog fullWidth={true} maxWidth={"sm"} open={editIndex !== null} onClose={() => setEditIndex(null)}>
				<DialogTitle>
					Editar URL {activeUrlKey && `de ${socialMediaList.find((item) => item.key === activeUrlKey)?.name}`}
				</DialogTitle>
				<DialogContent>
					{urlError && (
						<Alert severity="error" onClose={() => setUrlError(null)} sx={{ mb: 2 }}>
							{urlError}
						</Alert>
					)}
					<TextField
						fullWidth
						label="URL"
						onKeyDown={handleKeyDown}
						value={tempUrl}
						onChange={(e) => setTempUrl(e.target.value)}
						sx={{ marginTop: 1 }}
					/>
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={() => setEditIndex(null)}>
						Cancelar
					</Button>
					<Button loading={isLoading} onClick={handleSaveUrl} variant="contained">
						Guardar
					</Button>
				</DialogActions>
			</Dialog>

			{/* Modal para imagen */}
			<Dialog fullWidth={true} maxWidth={"md"} open={modalImageOpen} onClose={() => setModalImageOpen(false)}>
				<DialogTitle>Editar Imagen</DialogTitle>
				<DialogContent>
					<Button variant="contained" component="label" sx={{ mb: 2 }}>
						Añadir Imagen
						<input type="file" accept="image/*" hidden onChange={handleImageChange} />
					</Button>

					{previewImage && (
						<Box position="relative" mt={2}>
							<img src={previewImage} alt="Vista previa" style={{ maxWidth: "100%", borderRadius: 8 }} />
							<IconButton
								size="small"
								onClick={handleRemovePreview}
								sx={{
									"position": "absolute",
									"top": 5,
									"right": 5,
									"backgroundColor": "#e62e2d",
									"&:hover": { backgroundColor: "#e62e2d" },
								}}>
								<CloseIcon fontSize="small" sx={{ color: "#fff" }} />
							</IconButton>
						</Box>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setModalImageOpen(false)}>Cancelar</Button>
					<Button variant="contained" onClick={handleSaveImage} disabled={!previewImage}>
						Aceptar
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default HomeRedesEdit;
